import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { IResultPageState } from "@common/models";
import { BaseFpxFormComponent } from "@common/base-components";
import {
  TransactionSearchHelper,
  TransactionSearchState,
} from "./services/transaction-search.helper";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { API_DATE_FORMAT, REFERENCE_KEY } from "@common/constants";
import { ResultPageService } from "@common/services";
import { CommonService } from "src/app/common.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import moment from "moment";

@Component({
  selector: 'app-transaction-search',
  templateUrl: './transaction-search.component.html',
  styleUrls: ['./transaction-search.component.scss'],
  providers: [
    TransactionSearchHelper
  ]
})
export class TransactionSearchComponent extends BaseFpxFormComponent<TransactionSearchHelper, TransactionSearchState> {
  serviceCode: any;
  _trxSummary: any;
  accountNumber: any;
  data: any;
  fromMinDate = new Date();
  toMinDate = new Date();
  toMaxDate = new Date();

  constructor(
    _formBuilder: FormBuilder,
    private _router: Router,
    public _transactionSearchHelper: TransactionSearchHelper,
    private _accountsService: AccountsService,
    private _resultService: ResultPageService,
    protected _commonService: CommonService,
    private _matDialogRef: MatDialogRef<TransactionSearchComponent>
  ) {
    super(_formBuilder, _router, _transactionSearchHelper);
    this.serviceCode =
      this._router.getCurrentNavigation()?.extras?.state?.serviceCode || "";
  }

  override doPreInit() {
    this.initializeForm();
    document.body.classList.add("app-transaction-search");

    this.fromMinDate.setFullYear(this.fromMinDate.getFullYear() - 2);
    // this.toMinDate.setFullYear(this.fromMinDate.getFullYear() - 2);
    // this.toMinDate.setDate();

    // this.fromMinDate.setMonth(this.fromMinDate.getMonth() - 5);

    this.state.defaultDate = moment(new Date()).format(API_DATE_FORMAT);
  }

  initializeForm() {
    if(this.data?.screenData){
      this.accountNumber = this.data.screenData.accountNumber;
    }
    else {
      this.accountNumber = this.getRoutingParam(REFERENCE_KEY);
    }
    this.addFormControl(
      "accountNumber",
      this.accountNumber,
      [Validators.required],
      [],
      "change"
    );
    this.addFormControl("transPeriod", "", [Validators.required], [], "change");
    this.addFormControl("month", "", [Validators.required], [], "change");
    this.addFormControl("year", "", [Validators.required], [], "change");
    this.addFormControl(
      "fromDate",
      // moment(new Date()).format(API_DATE_FORMAT),
      "",
      [Validators.required],
      [],
      "change"
    );
    this.addFormControl("toDate", "", [Validators.required], [], "change");
    this.addFormControl(
      "displayDownload",
      "1",
      [Validators.required],
      [],
      "change"
    );
    this.formGroup.patchValue({ transPeriod: "1" });
  }

  protected override doPostInit() {}

  override doSubmit(formGroup: FormGroup) {
    let methodName =
      formGroup.controls["displayDownload"].value == "1"
        ? "transactionSearch"
        : "transactionDownload";
    this._transactionSearchHelper.doSubmit(
      methodName,
      formGroup.value,
      (res) => {
        document.body.classList.remove("info-popup");
        if (methodName == "transactionDownload") {
          this._matDialogRef.close();
          return;
        } else {
          if (res) res["filteredData"] = formGroup.value;
          this._matDialogRef.close(res);
        }
      },
      (err) => {
        document.body.classList.remove('info-popup');
        // this._resultService.setFailure();
        // this._resultService.setResultPayload(err);
        // this.navigateToResultPage(this._resultService.resultPageData);
      });
  }
  resetForm() {
    this.formGroup.reset();
    this.formGroup.patchValue({'transPeriod': '1'});
    this.formGroup.patchValue({'displayDownload': '1'});
  }
  protected doDestroy(): void {
    document.body.classList.remove('app-transaction-search');
  }

}
